module.exports = __webpack_public_path__ + "static/media/BauPro.82d38575.eot";